import { MemberMembershipDataType } from '../services/useMembershipQueryService';

const toFiniteNumber = (value: unknown): number | undefined => {
    if (value === '' || value === null || value === undefined) return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
};

/**
 * 레거시 PT 및 MemberTicket compat 응답의 명칭/회차 alias와 숫자 문자열을 현재 상세 shape로 맞춘다.
 * 식별자나 회차를 추측하지 않고, 서버가 실제로 내려준 동등 필드만 정규화한다.
 */
export const normalizeMembershipDetail = (membership?: unknown): Partial<MemberMembershipDataType> | null => {
    if (!membership || typeof membership !== 'object' || Array.isArray(membership)) return null;
    const raw = membership as Record<string, unknown>;
    return {
        ...membership,
        name: String(raw.name || raw.membershipName || raw.ticketName || '').trim(),
        totalSession: toFiniteNumber(raw.totalSession ?? raw.totalCount),
        currentSession: toFiniteNumber(raw.currentSession ?? raw.usedCount),
        remainSession: toFiniteNumber(raw.remainSession ?? raw.remainingCount),
    } as Partial<MemberMembershipDataType>;
};

/**
 * 환불·삭제·회차 변경 같은 관리 액션을 열어도 되는 최소 수강권 shape.
 * _id만 있는 인계/아카이브 응답을 정상 상세로 오인하지 않게 숫자 필드까지 확인한다.
 */
export const isActionableMembershipDetail = (
    membership?: Partial<MemberMembershipDataType> | null,
): membership is MemberMembershipDataType =>
    !!membership &&
    typeof membership._id === 'string' &&
    membership._id.trim().length > 0 &&
    typeof membership.memberId === 'string' &&
    membership.memberId.trim().length > 0 &&
    typeof membership.name === 'string' &&
    membership.name.trim().length > 0 &&
    typeof membership.totalSession === 'number' &&
    Number.isFinite(membership.totalSession) &&
    typeof membership.currentSession === 'number' &&
    Number.isFinite(membership.currentSession) &&
    typeof membership.remainSession === 'number' &&
    Number.isFinite(membership.remainSession);
